export default class MatchMedia {
    constructor() {

        this.mobileMax = 47.9375; //767
        this.tabletMin = 48; //768
        this.tabletMax = 63.9375; //1023
        this.desktopSmallMin = 64; //1024
        this.desktopSmallMax = 94.5; //1512
        this.desktopLargeMin = 94.5625; //1513

        this.isMobile = false;
        this.isTablet = false;
        this.isDesktopSmall = false;
        this.isDesktopLarge = false;

        this.listen();
        this.checkWindowWidth();
    }

    listen() {
        window.addEventListener("resize", () => {
            this._resize();
        });
    }

    checkWindowWidth() {
        if(window.matchMedia(`(max-width: ${this.mobileMax}rem)`).matches) {
            this.isMobile = true;
            this.isTablet = false;
            this.isDesktopSmall = false;
            this.isDesktopLarge = false;
        } else if(window.matchMedia(`screen and (min-width: ${this.tabletMin}rem) and (max-width: ${this.tabletMax}rem)`).matches) {
            this.isMobile = false;
            this.isTablet = true;
            this.isDesktopSmall = false;
            this.isDesktopLarge = false;
        } else if(window.matchMedia(`screen and (min-width: ${this.desktopSmallMin}rem) and (max-width: ${this.desktopSmallMax}rem)`).matches) {
            this.isMobile = false;
            this.isTablet = false;
            this.isDesktopSmall = true;
            this.isDesktopLarge = false;
        } else {
            this.isMobile = false;
            this.isTablet = false;
            this.isDesktopSmall = false;
            this.isDesktopLarge = true;
        }
    }

    _resize() {
        this.checkWindowWidth();
    }
}